import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import CreateRoomForm from '../components/CreateRoomForm.jsx';

export default function Home() {
	const navigate = useNavigate();

	// refs
	const rootRef = useRef(null);
	const titleLine1Ref = useRef(null);
	const titleLine2Ref = useRef(null);
	const subtitleRef = useRef(null);
	const featuresGridRef = useRef(null);
	const cardsRef = useRef(null);
	const heroRef = useRef(null);
	const preRef = useRef(null);

	const [immediateMatch, setImmediateMatch] = useState(null);
	const [copyFeedback, setCopyFeedback] = useState(false);

	const reduceMotion = useMemo(
		() => window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches,
		[]
	);

	useEffect(() => {
		document.querySelector('body').className = 'trivia-home trivia-light-green';
	}, []);

	const handleCopyCode = async () => {
		if (!preRef.current) return;

		const text = preRef.current.textContent.trim();

		try {
			await navigator.clipboard.writeText(text);
			setCopyFeedback(true);
			setTimeout(() => setCopyFeedback(false), 2000);
		} catch (err) {
			console.error('Errore nella copia:', err);
		}
	};

	return (
		<>
			<img className="bg-image" src={`/img/react-app/bg-oliva-right.png`} />
			<div className="home-landing quick-match mb-lg-15" ref={rootRef}>

				<section className="hero container align-items-start" ref={heroRef}>
					<div className="hero__copy pe-lg-5">
						<h1 className="hero__title">
							<span className="title-gradient d-block mb-2" style={{ fontSize: "2.8rem", lineHeight: "1" }} ref={titleLine2Ref}>Trivia Game - Gioca con Oleario</span>
							<span className="title-line fs-1" ref={titleLine1Ref}>Crea una partita immediata</span>
						</h1>
						<div className="hero__subtitle fs-4 lh-sm mt-4" ref={subtitleRef}>
							<strong className="fw-bold d-block mb-2 text-uppercase">GIOCA CON OLEARIO E SCOPRI QUANTO CONOSCI L'OLIO!</strong>
							<p>
								Un percorso divertente, attraverso una serie di domande
								anche a risposta multipla ti permetteranno di approfondire, da
								solo o in gruppo, quanti temi siano legati all'ulivo e al suo
								prodotto d'eccellenza.
								<br />
								Buon divertimento... e che vinca il migliore!
							</p>
						</div>
					</div>
					<div>
						{immediateMatch ?
							<div className="match-created fs-5 mt-lg-4">

								<h2 className="title-line fs-1 d-flex align-items-center lh-1" style={{ fontWeight: 900 }}>
									<i className="bi bi-check ms-n3"></i>
									Partita creata!
								</h2>
								<div className="lh-sm">
									Questo è il codice da distribuire agli altri giocatori:
								</div>

								<div className="position-relative d-flex align-items-center">
									<pre className="display-2 m-0 fw-bold text-warning" ref={preRef}>{immediateMatch.participationCode}</pre>
									<i
										style={{ cursor: "pointer" }}
										title="Copia il codice negli appunti"
										onClick={handleCopyCode}
										className={`fs-2 ms-3 bi ${copyFeedback ? 'bi-check-circle' : 'bi-clipboard'}`}></i>
								</div>

								<h3 className="fs-5">
									<p>Questo codice andrà inserito nella <a href="/trivia" className="text-white" style={{ textDecoration: "underline" }} target="_blank">Homepage</a>.</p>
									<p>
										Se invece vuoi osservare l'andamento della partita
										<br /><a style={{ textDecoration: "underline" }} target="_blank" href={`/trivia/${immediateMatch.teacherSessionId}`} className="text-white">vai su questa pagina</a>.
									</p>
								</h3>
							</div>
							:
							<CreateRoomForm onCreated={(res) => {
								console.log('created', res);
								setImmediateMatch(res);
							}} />
						}

					</div>
				</section>
			</div>
		</>

	);
}
